var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.node,{tag:"component",staticClass:"cs-button button",class:[_vm.iconClass, _vm.disabledClass, _vm.spinnerClass],on:{"click":function($event){return _vm.clickHandler($event)}}},[_vm._t("default"),(_vm.spinner)?_c('cs-spinner'):_vm._e()],2)
}
var staticRenderFns = []

export { render, staticRenderFns }